import axios from "axios"
import { API_BASE_URL } from "../config"

export const getManageAccountItem = async (id: string) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/account/item`, {
        id: id,
        session_code: localStorage.getItem("session_code")
      })

      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
